import { __assign } from "tslib";
import { useCallback, useContext, useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { isLoggableClickEvent } from '@wix/da-bi/pkg/hooks/useBiClickLogger';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SCROLL_THROTTLE_TIMEOUT } from '../constants';
/** Handle scroll-related events - mobile swipes and desktop arrow clicks */
export function useSliderScrollHandler(contentRef, scrollBy, onScrollBiData, enableMobileSwipeLogging) {
    var isMobile = useContext(MobileContext);
    var hasLoggedMobileSwipe = useRef(false);
    var logBiEvent = useBiLogger();
    var logMobileSwipe = isMobile && enableMobileSwipeLogging;
    var logArrowClickEvent = useCallback(function (contentNode, direction) {
        var contentWidth = contentNode.getBoundingClientRect().width;
        var scrollableArea = contentNode.scrollWidth - contentWidth;
        var perc = contentNode.scrollLeft / scrollableArea;
        logBiEvent(__assign(__assign({}, onScrollBiData), { evid: BiEventType.CAROUSEL_ARROW_CLICK, scroll_pct: Math.round(100 * perc), direction: direction }));
    }, [logBiEvent, onScrollBiData]);
    useEffect(function () {
        var contentNode = contentRef.current;
        if (!contentNode) {
            return;
        }
        var handleScroll = throttle(function () {
            if (logMobileSwipe && !hasLoggedMobileSwipe.current) {
                logArrowClickEvent(contentNode);
                hasLoggedMobileSwipe.current = true;
            }
        }, SCROLL_THROTTLE_TIMEOUT, { leading: true });
        contentNode.addEventListener('scroll', handleScroll);
        return function () { return contentNode.removeEventListener('scroll', handleScroll); };
    }, [contentRef, logArrowClickEvent, logMobileSwipe]);
    var handleScrollButtonClick = useCallback(function (e, direction) {
        // capture this here so we don't need to use e.persist
        var isLoggable = isLoggableClickEvent(e.nativeEvent);
        requestAnimationFrame(function () {
            var contentNode = contentRef.current;
            if (!contentNode || !scrollBy) {
                return;
            }
            if (isLoggable) {
                logArrowClickEvent(contentNode, direction);
            }
            var contentWidth = contentNode.getBoundingClientRect().width;
            var scrollLeft = scrollBy <= 1 ? contentWidth * scrollBy : scrollBy;
            if (direction === 'previous') {
                contentNode.scrollLeft -= scrollLeft;
            }
            else if (direction === 'next') {
                contentNode.scrollLeft += scrollLeft;
            }
        });
    }, [contentRef, scrollBy, logArrowClickEvent]);
    return handleScrollButtonClick;
}
//# sourceMappingURL=useSliderScrollHandler.js.map